// extracted by mini-css-extract-plugin
export default {"container":"feed-status_container__wU3nT","info":"feed-status_info__mTjXo","img":"feed-status_img__9EtOn","number":"feed-status_number__rxbg0"};